"use client";

import { Phone, Sparkles, Star, Heart, Zap } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function IndustryAccess() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="1191" id="industry-access" className="bg-background text-foreground relative overflow-hidden" style={{
    backgroundColor: "hsl(240 30% 2%)"
  }}>
      {}
      <svg className="absolute top-0 left-0 w-full h-6 z-10" viewBox="0 0 1200 24" preserveAspectRatio="none" aria-hidden="true">
        <path d="M0,0 L0,12 L40,18 L80,8 L120,16 L160,10 L200,20 L240,12 L280,18 L320,6 L360,16 L400,10 L440,20 L480,8 L520,14 L560,18 L600,10 L640,20 L680,12 L720,16 L760,8 L800,18 L840,10 L880,20 L920,12 L960,16 L1000,8 L1040,18 L1080,12 L1120,20 L1160,10 L1200,16 L1200,0 Z" fill="hsl(320 100% 55%)" />
      </svg>

      {}
      <svg className="absolute bottom-0 left-0 w-full h-6 z-10 rotate-180" viewBox="0 0 1200 24" preserveAspectRatio="none" aria-hidden="true">
        <path d="M0,0 L0,12 L40,18 L80,8 L120,16 L160,10 L200,20 L240,12 L280,18 L320,6 L360,16 L400,10 L440,20 L480,8 L520,14 L560,18 L600,10 L640,20 L680,12 L720,16 L760,8 L800,18 L840,10 L880,20 L920,12 L960,16 L1000,8 L1040,18 L1080,12 L1120,20 L1160,10 L1200,16 L1200,0 Z" fill="hsl(240 15% 20%)" />
      </svg>

      {}
      <svg className="absolute top-16 left-4 md:top-24 md:left-16 w-20 h-20 md:w-32 md:h-32 opacity-40 pointer-events-none" viewBox="0 0 100 100" fill="none" aria-hidden="true">
        <path d="M50 10 L58 38 L88 42 L64 60 L72 88 L50 72 L28 88 L36 60 L12 42 L42 38 Z" stroke="hsl(320 100% 55%)" strokeWidth="4" strokeLinejoin="round" fill="none" />
      </svg>

      {}
      <svg className="absolute top-20 right-6 md:top-28 md:right-20 w-16 h-16 md:w-28 md:h-28 opacity-40 pointer-events-none" viewBox="0 0 100 100" fill="none" aria-hidden="true">
        <path d="M50 5 L50 35" stroke="hsl(0 0% 98%)" strokeWidth="4" strokeLinecap="round" />
        <path d="M50 65 L50 95" stroke="hsl(0 0% 98%)" strokeWidth="4" strokeLinecap="round" />
        <path d="M5 50 L35 50" stroke="hsl(0 0% 98%)" strokeWidth="4" strokeLinecap="round" />
        <path d="M65 50 L95 50" stroke="hsl(0 0% 98%)" strokeWidth="4" strokeLinecap="round" />
        <path d="M18 18 L38 38" stroke="hsl(0 0% 98%)" strokeWidth="4" strokeLinecap="round" />
        <path d="M62 62 L82 82" stroke="hsl(0 0% 98%)" strokeWidth="4" strokeLinecap="round" />
        <path d="M82 18 L62 38" stroke="hsl(0 0% 98%)" strokeWidth="4" strokeLinecap="round" />
        <path d="M38 62 L18 82" stroke="hsl(0 0% 98%)" strokeWidth="4" strokeLinecap="round" />
      </svg>

      {}
      <svg className="absolute bottom-20 right-4 md:bottom-28 md:right-16 w-20 h-20 md:w-32 md:h-32 opacity-40 pointer-events-none" viewBox="0 0 100 100" fill="none" aria-hidden="true">
        <path d="M50 20 C 30 20 20 35 20 50 C 20 65 35 75 50 75 C 60 75 70 70 70 60 C 70 52 64 48 58 48 C 52 48 48 52 48 58" stroke="hsl(320 100% 55%)" strokeWidth="4" strokeLinecap="round" fill="none" />
      </svg>

      {}
      <svg className="absolute bottom-16 left-6 md:bottom-24 md:left-20 w-16 h-16 md:w-28 md:h-28 opacity-40 pointer-events-none" viewBox="0 0 100 100" fill="none" aria-hidden="true">
        <circle cx="50" cy="50" r="40" stroke="hsl(240 15% 20%)" strokeWidth="4" fill="none" />
        <path d="M50 10 L50 90" stroke="hsl(240 15% 20%)" strokeWidth="4" strokeLinecap="round" />
        <path d="M50 50 L20 78" stroke="hsl(240 15% 20%)" strokeWidth="4" strokeLinecap="round" />
        <path d="M50 50 L80 78" stroke="hsl(240 15% 20%)" strokeWidth="4" strokeLinecap="round" />
      </svg>

      {}
      <div className="absolute top-2 left-4 md:top-4 md:left-12 z-20 -rotate-[8deg]" style={{
      backgroundColor: "hsl(320 100% 55%)",
      border: "1px solid hsl(0 0% 98%)",
      borderRadius: "0rem",
      padding: "0.5rem 1.25rem",
      boxShadow: "0px 0px 0px transparent",
      color: "hsl(240 30% 2%)"
    }}>
        <span className="font-mono text-sm md:text-base tracking-widest flex items-center gap-2 font-medium">
          <Star className="w-4 h-4 fill-current" strokeWidth={2} />
          WORLD TOUR 2024
          <Zap className="w-4 h-4 fill-current" strokeWidth={2} />
        </span>
      </div>

      {}
      <Sparkles className="absolute top-32 left-1/4 w-8 h-8 opacity-50 pointer-events-none" style={{
      color: "hsl(320 100% 55%)"
    }} strokeWidth={2} aria-hidden="true" />
      <Heart className="absolute bottom-32 right-1/3 w-8 h-8 opacity-50 pointer-events-none" style={{
      color: "hsl(0 0% 98%)"
    }} strokeWidth={2} aria-hidden="true" />

      {}
      <div ref={ref} className="relative z-10 max-w-5xl mx-auto px-6 md:px-10 lg:px-16 py-32 md:py-44 text-center" style={{
      transform: isVisible ? "translateY(0)" : "translateY(24px)",
      opacity: isVisible ? 1 : 0,
      transition: "transform 800ms cubic-bezier(0.16, 1, 0.3, 1), opacity 800ms ease-out"
    }}>
        {}
        <p className="font-mono uppercase font-medium tracking-[0.2em] text-xs md:text-sm mb-6" style={{
        color: "hsl(320 100% 55%)"
      }}>
          Industry & Media Access
        </p>

        {}
        <h1 className="font-default font-extrabold leading-[0.9] tracking-tighter mb-8" style={{
        fontSize: "clamp(3rem, 8vw, 7rem)",
        color: "hsl(0 0% 98%)"
      }}>
          <span className="block">ACCESS THE</span>
          <span className="relative inline-block mt-2">
            <span className="relative z-10 px-4">ECLIPSE</span>
            {}
            <svg className="absolute inset-0 w-full h-full pointer-events-none" viewBox="0 0 300 140" preserveAspectRatio="none" aria-hidden="true" style={{
            overflow: "visible"
          }}>
              <path d="M150,12 C 70,14 18,38 14,72 C 12,108 78,128 152,128 C 232,128 290,108 288,72 C 286,38 224,16 150,12 Z" fill="none" stroke="hsl(320 100% 55%)" strokeWidth="2" strokeLinecap="round" style={{
              strokeDasharray: 800,
              strokeDashoffset: isVisible ? 0 : 800,
              transition: "stroke-dashoffset 1200ms ease-out 400ms"
            }} />
            </svg>
          </span>
        </h1>

        {}
        <p className="font-default font-normal mx-auto max-w-2xl mb-10 md:mb-12" style={{
        fontSize: "clamp(1.125rem, 1.5vw, 1.25rem)",
        lineHeight: 1.6,
        color: "hsl(240 10% 60%)"
      }}>
          Download the official Digital Press Kit for tour assets, high-res photography, and technical riders.
        </p>

        {}
        <p className="font-mono mb-10 -rotate-1 inline-block" style={{
        fontSize: "clamp(1rem, 1.2vw, 1.25rem)",
        color: "hsl(320 100% 55%)"
      }}>
          LAT: 34.0522 / LON: 118.2437
        </p>

        {}
        <div className="flex flex-col sm:flex-row gap-4 sm:gap-5 justify-center items-stretch sm:items-center max-w-md sm:max-w-none mx-auto">
          <Button asChild className="font-default font-bold uppercase tracking-wide text-base md:text-lg px-8 py-7 border-none transition-all duration-200 hover:translate-x-1" style={{
          backgroundColor: "hsl(320 100% 55%)",
          color: "hsl(240 30% 2%)",
          boxShadow: "none"
        }}>
            <Link to="/EclipsePage">
              <Sparkles className="w-5 h-5" strokeWidth={2} />
              DOWNLOAD EPK
            </Link>
          </Button>

          <Button asChild className="font-default font-bold uppercase tracking-wide text-base md:text-lg px-8 py-7 border transition-all duration-200 hover:translate-x-1 bg-transparent" style={{
          color: "hsl(0 0% 98%)",
          borderColor: "hsl(240 15% 20%)",
          boxShadow: "none"
        }} onMouseEnter={e => {
          e.currentTarget.style.borderColor = "hsl(320 100% 55%)";
        }} onMouseLeave={e => {
          e.currentTarget.style.borderColor = "hsl(240 15% 20%)";
        }}>
            <Link to="#">
              <Phone className="w-5 h-5" strokeWidth={2} />
              BOOKING INQUIRY
            </Link>
          </Button>
        </div>

        {}
        <p className="font-mono font-medium mt-10 text-xs tracking-widest uppercase" style={{
        color: "hsl(240 10% 60%)"
      }}>
          Global Representation · 2024 Tour Assets · High-Res Gallery
        </p>
      </div>
    </section>;
}